import { type JobStatus } from '@blaze-shared/api-contracts-domain';

export const JOB_FINISH_STATUSES = new Set<JobStatus>([
  'RanToCompletion',
  'Faulted',
  'Abandoned',
  'Canceled',
]);
